import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    inject,
    OnDestroy,
    OnInit
} from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { EventService } from "~app/common/services/cqs/event.service";
import { ToggleViapunktReadonlyEvent, ViapunktAddedEvent } from "~app/features/transport/transportplanera/components/tpl-transportavstand-modal/tpl-transportavstand-eventhandler";
import { BlockComponent } from "../../../../container-block/block.component";
import { MapClickedEvent } from "../../../map.events";
import { IMapComponent } from "../../../map.models";
import { IMapSettings } from "../../../map.settings";
import { MapBaseSubComponent } from "../map-base-sub-component/map-base-sub.component";

@Component({
    selector: "rask-map-viapunkter",
    templateUrl: "./map-viapunkter.component.html",
    styleUrls: ["./map-viapunkter.component.scss"],
    providers: [
        { provide: MapBaseSubComponent,
            useExisting: forwardRef(() => MapViapunkterComponent) }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [BlockComponent]
})
export class MapViapunkterComponent extends MapBaseSubComponent implements OnInit, OnDestroy {
    widgetId = "viapunkter";
    buttons = [
        {
            iconClass: "fa-map-marker-plus",
            tooltipText: "Via-punkter",
            visible: this.isEnabled(),
            disabled: this.disabled,
            widgetId: this.widgetId
        }
    ];
    canEdit = false;
    map: IMapComponent;
    mapsettings: IMapSettings;
    panelFormExpanded = false;
    panelMapExpanded = false;

    private readonly eventService = inject(EventService);

    constructor() {
        super();
    }

    initEventListeners() {
        this.eventService.subscribeEvent("MapClickedEvent").pipe(
            takeUntil(this.destroy$)
        ).subscribe((event: MapClickedEvent) => {
            if (this.canEdit) {
                const viapunktAddedEvent = new ViapunktAddedEvent(event.point, event.coords);
                this.eventService.emit(viapunktAddedEvent);
                this.canEdit = false;
            }
        });
        this.eventService.subscribeEvent("ToggleViapunktReadonlyEvent").pipe(
            takeUntil(this.destroy$)
        ).subscribe((event: ToggleViapunktReadonlyEvent) => {
            this.canEdit = !event.readonly;
            this.buttons.forEach(button => {
                button.disabled = event.readonly;
            });
        });
    }

    isEnabled() {
        return !this.disabled;
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.canEdit = false;
    }

    ngOnInit(): void {
        this.canEdit = false;
        this.mapReady.pipe(
            takeUntil(this.destroy$)
        ).subscribe(instance => {
            this.map = instance;
        });

        this.onShow.pipe(
            takeUntil(this.destroy$)
        ).subscribe(() => {
            this.canEdit = true;
        });

        this.onHide.pipe(
            takeUntil(this.destroy$)
        ).subscribe(() => {
            this.canEdit = false;
        });

        this.initEventListeners();
    }

    preInit(mapsettings: IMapSettings) {
        this.mapsettings = mapsettings;
    }
}
